import _ from 'underscore'
import api from '../../libs/Api'
import repos from '../../libs/Repository'
import * as types from './types'
import utils from '@/libs/Utils'
import Constants from '@/constants'

export default {
  namespaced: true,
  state: {
    profile: null
  },
  mutations: {
    [types.SET_PROFILE] (state, value) {
      state.profile = value
    }
  },
  actions: {
    clearSession () {
      repos.clearToken()
    },
    async reloadServiceCodeAsync () {
      const serviceTypes = await api.getServiceCode()
      repos.setServiceTypes(serviceTypes)
    },
    async reloadTeresaStandardServiceCodeAsync () {
      const serviceTypes = await api.getTeresaStandardServiceCode()
      repos.setServiceTypes(serviceTypes)
    },
    async loginAsync ({ commit }, { loginId, password }) {
      const subDomain = window.location.hostname.split('.')[0]
      await api.login(subDomain, loginId, password)
      const profile = await api.profile()
      const isTeresaStandard = (Constants.FunctionMask.TeresaStandard & profile.site.function_mask) === Constants.FunctionMask.TeresaStandard
      const isNativeCode = (Constants.FunctionMask.NATIVE_CODE & profile.site.function_mask) === Constants.FunctionMask.NATIVE_CODE
      let serviceTypes = null
      if (isTeresaStandard || isNativeCode) {
        serviceTypes = await api.getTeresaStandardServiceCode()
      } else {
        serviceTypes = await api.getServiceCode()
      }
      const codes = await api.getCode()
      repos.setReportSearchParams(null)
      repos.setCodes(codes)
      repos.setServiceTypes(serviceTypes)
      commit(types.SET_PROFILE, profile)
    },
    async loginFreeAsync ({ commit }, { subDomain, loginId, password }) {
      console.info(subDomain)
      await api.login(subDomain, loginId, password)
      const profile = await api.profile()
      const serviceTypes = await api.getServiceCode()
      const codes = await api.getCode()
      repos.setReportSearchParams(null)
      repos.setCodes(codes)
      repos.setServiceTypes(serviceTypes)
      commit(types.SET_PROFILE, profile)
    },
    async logoutAsync () {
      return api.logout()
    }
  },
  getters: {
    isLoggedIn () {
      return !!(repos.getToken())
    },
    getServiceTypes () {
      return repos.getServiceTypes()
    },
    getServiceTypeGroups: () => (serviceTypeId) => {
      const serviceTypes = repos.getServiceTypes()
      const serviceType = _.chain(serviceTypes)
        .find(serviceType => {
          return Number(serviceType.id) === Number(serviceTypeId)
        })
        .value()
      return (serviceType) ? serviceType.service_type_groups : []
    },
    getServiceTypeGroupItems: () => (serviceTypeGroups, serviceTypeGroupId) => {
      const serviceTypeGroup = _.chain(serviceTypeGroups)
        .find(serviceTypeGroup => {
          return serviceTypeGroup.id === serviceTypeGroupId
        })
        .value()
      return (serviceTypeGroup) ? serviceTypeGroup.service_type_group_items : []
    },
    // さくら版: マスタ上 apply_start_date が 1999-01-01 00:00:00 の行だけを候補にする（制度改正用の新旧行は出さない）
    getServiceCodes: (state, getters, rootState) => (serviceTypeId, _targetDate, specificOfficeAdditionCd = null) => {
      const profile = rootState.session?.profile
      const isSakura = profile
        ? (Constants.FunctionMask.SAKURA & profile.site.function_mask) === Constants.FunctionMask.SAKURA
        : false

      const serviceTypes = repos.getServiceTypes()
      const serviceType = _.chain(serviceTypes)
        .find(serviceType => {
          return Number(serviceType.id) === Number(serviceTypeId)
        })
        .value()

      const serviceCodes = (serviceType) ? serviceType.service_codes : []

      const sakuraApplyStartMark = utils.covert2Dayjs('1999-01-01 00:00:00', 'YYYY-MM-DD HH:mm:ss')
      const isSakuraMarkedServiceCode = (serviceCode) => {
        const applyStartDate = utils.covert2Dayjs(serviceCode.apply_start_date, 'YYYY-MM-DD HH:mm:ss')
        return applyStartDate.isValid() && applyStartDate.isSame(sakuraApplyStartMark)
      }

      if (isSakura) {
        let list = _.filter(serviceCodes, isSakuraMarkedServiceCode)
        if (specificOfficeAdditionCd) {
          list = _.filter(list, (sc) => sc.specific_office_addition_cd === specificOfficeAdditionCd)
        }
        return list
      }

      if (specificOfficeAdditionCd) {
        return _.filter(serviceCodes, (serviceCode) => {
          const applyStartDate = utils.covert2Dayjs(serviceCode.apply_start_date, 'YYYY-MM-DD HH:mm:ss')
          const isOk = serviceCode.specific_office_addition_cd === specificOfficeAdditionCd
          return isOk && applyStartDate.isSame(sakuraApplyStartMark)
        })
      }

      return _.filter(serviceCodes, (serviceCode) => {
        const applyStartDate = utils.covert2Dayjs(serviceCode.apply_start_date, 'YYYY-MM-DD HH:mm:ss')
        const applyEndDate = utils.covert2Dayjs(serviceCode.apply_end_date, 'YYYY-MM-DD HH:mm:ss')
        const targetDate = utils.covert2Dayjs(_targetDate, 'YYYY-MM-DD')
        return ((applyStartDate.isBefore(targetDate) || applyStartDate.isSame(targetDate)) && (!applyEndDate || applyEndDate.isAfter(targetDate)))
      })
    },
    getServiceUniqueCodes: () => (serviceTypeId) => {
      const serviceTypes = repos.getServiceTypes()
      const serviceType = _.chain(serviceTypes)
        .find(serviceType => {
          return Number(serviceType.id) === Number(serviceTypeId)
        })
        .value()
      return (serviceType) ? serviceType.service_unique_codes : []
    },
    getTeresaStandardServiceUniqueCodes: () => (serviceTypeId) => {
      const serviceTypes = repos.getServiceTypes()
      const serviceType = _.chain(serviceTypes)
        .find(serviceType => {
          return Number(serviceType.id) === Number(serviceTypeId)
        })
        .value()
      return (serviceType) ? serviceType.service_teresa_unique_codes : []
    },
    getCareItemSets: () => (serviceTypeId) => {
      const serviceTypes = repos.getServiceTypes()
      const serviceType = _.chain(serviceTypes)
        .find(serviceType => {
          return Number(serviceType.id) === Number(serviceTypeId)
        })
        .value()
      return (serviceType) ? serviceType.care_item_sets : []
    },
    getCodes: () => (codeGroup) => {
      const codes = repos.getCodes()
      return _.chain(codes)
        .filter(code => {
          return code.code_group === codeGroup
        })
        .value()
    }
  }
}
